import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
const uuid = require('uuid');

const Strings = require('../../../../app/shared/Strings');
const StringUtil = require('../../../../app/shared/StringUtil');
const AnalyticsStore = require('../../stores/AnalyticsStore');
const AnalyticsActions = require('../../actions/AnalyticsActions');
const ChannelStore = require('../../stores/channel_store_reflux');
const Globals = require('../../../../app/globals');
import SortableTable2 from '../table/SortableTable2';

const propTypes = {
    className: PropTypes.string,
    activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

const defaultProps = {
    className: ''
};

class ChannelActivityAssignmentsTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            channelStoreState: ChannelStore.getStateChannel(props.channelId),
            analyticsStoreState: AnalyticsStore.getState(),
            getActAssignmentsId: null,
        };

        this.getAssignmentData = this.getAssignmentData.bind(this);

        this.unsubscribes = [
            AnalyticsStore.listen(this.onAnalyticsStoreChange.bind(this)),
            ChannelStore.listen(this.onChannelStoreChange.bind(this)),
        ];
    }

    componentDidMount() {
        this.getAssignmentData(this.props.channelId, this.props.activityId);
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.activityId !== this.props.activityId
            && !this.state.analyticsStoreState.activityAssignments[this.props.activityId]
        ) {
            this.getAssignmentData(this.props.channelId, this.props.activityId);
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    getAssignmentData(channelId, activityId) {
        const getActAssignmentsId = uuid.v4();
        this.setState({ getActAssignmentsId: getActAssignmentsId }, () => {
            AnalyticsActions.getActivityAssignmentStatsChannel(
                getActAssignmentsId,
                {
                    activityId: activityId,
                    channelId: channelId
                }
            );
        });
    }

    onChannelStoreChange(state) {
        this.setState({
            channelStoreState: ChannelStore.getStateChannel(this.props.channelId),
        })
    }

    onAnalyticsStoreChange(state) {
        let additionalState = {};
        if (state.action.id === this.state.getActAssignmentsId) {
            additionalState.getActAssignmentsId = null;
        }

        this.setState({ analyticsStoreState: state, ...additionalState });
    }

    render() {
        const rawAssignments = this.state.analyticsStoreState.activityAssignments[this.props.activityId];
        if (!rawAssignments) {
            return null;
        }

        // derive a display label so the Type column sorts by label rather than by integration type code
        const integrationTypeLabels = Strings['en'].analytics.overview.assignment_table.integration_types;
        const assignments = rawAssignments.map(assn => ({
            ...assn,
            integration_type_display: !assn.integration_type
                ? ''
                : (Object.prototype.hasOwnProperty.call(integrationTypeLabels, assn.integration_type)
                    ? integrationTypeLabels[assn.integration_type]
                    : assn.integration_type),
        }));

        let displayColumnCallbacksId = {};
        const currentChannel = this.state.channelStoreState.channel;
        if (!!currentChannel) {
            // use an 'a' element instead of Link component to ensure server request is made and Connect/LTI client served
            switch (currentChannel.user_role_token) {
                case Globals.users.roles.CHANNEL_OWNER:
                    displayColumnCallbacksId.name = (assnId) => {
                        const assignment = assignments.find(assn => assn.id === assnId);
                        if (assignment.integration_type === Globals.integration_type.LOCAL) {
                            return <a href={`/assignment/${assignment.hash}/mzl_instructor`} title={assignment.name}>{assignment.name}</a>;
                        }
                        else if (
                            assignment.integration_type === Globals.integration_type.LTI
                            || assignment.integration_type === Globals.integration_type.LTI_1_3
                        ) { // TODO: leaving this around for now. should be removed once all user -> org transitions are complete.
                            return <a href={`/assignment/${assignment.hash}/admin`} title={assignment.name}>{assignment.name}</a>;
                        }
                        else {
                            return <span title={assignment.name}>{assignment.name}</span>;
                        }
                    }

                    break;
                case Globals.users.roles.ORG_OWNER:
                case Globals.users.roles.ORG_ADMIN:
                    displayColumnCallbacksId.name = (assnId) => {
                        const assignment = assignments.find(assn => assn.id === assnId);
                        if (
                            assignment.integration_type === Globals.integration_type.LTI
                            || assignment.integration_type === Globals.integration_type.LTI_1_3
                        ) {
                            return <a href={`/assignment/${assignment.hash}/admin`} title={assignment.name}>{assignment.name}</a>;
                        }
                        else if (assignment.integration_type === Globals.integration_type.CONNECT) {
                            return <a href={`/connect/report/admin/${assignment.hash}`} title={assignment.name}>{assignment.name}</a>;
                        }
                        else if (assignment.integration_type === Globals.integration_type.LOCAL) {
                            return <a href={`/assignment/${assignment.hash}/admin?integration=${Globals.integration_type.LOCAL}`} title={assignment.name}>{assignment.name}</a>;
                        }
                        else if (assignment.integration_type === Globals.integration_type.VANTAGE) {
                            return <a href={`/vantage/report/admin/${assignment.hash}`} title={assignment.name}>{assignment.name}</a>;
                        }
                        else {
                            return <span title={assignment.name}>{assignment.name}</span>;
                        }
                    }
                    break;
                default:
                    break;
            }
        }

        return (
            <div className={`${this.props.className}`}>
                <SortableTable2
                    classNameTable="font-size-md"
                    rows={assignments}
                    rowsPerPage={100}
                    dateFormat="YYYY-MM-DD"
                    defaultSort={{ key: 'create_date', type: 'date', asc: false }}
                    displayColumnCallbacksId={displayColumnCallbacksId}
                    displayColumnCallbacks={{
                        'student_count': (num) => StringUtil.numberToLocaleString(num),
                        'started_attempt_count': (num) => StringUtil.numberToLocaleString(num),
                        'completed_attempt_count': (num) => StringUtil.numberToLocaleString(num),
                    }}
                    topGroupHeader= {[
                        {
                            displayName: '',
                            colSpan: '5'
                        },
                        {
                            displayName: Strings['en'].analytics.overview.assignment_table.POLICY,
                            colSpan: '2'
                        },
                        {
                            displayName: Strings['en'].analytics.overview.assignment_table.ATTEMPTS,
                            colSpan: '3'
                        },
                        {
                            displayName: Strings['en'].analytics.overview.assignment_table.TIME_PLAYED,
                            colSpan: '2'
                        },
                        {
                            displayName: Strings['en'].analytics.overview.assignment_table.SCORE,
                            colSpan: '1'
                        }
                    ]}
                    columns={[
                            {
                                displayName: Strings['en'].analytics.overview.assignment_table.NAME,
                                key: 'name',
                                type: 'string'
                            },
                            {
                                displayName: Strings['en'].analytics.overview.assignment_table.COURSE,
                                key: 'course_name',
                                type: 'string'
                            },
                            {
                                displayName: Strings['en'].analytics.overview.assignment_table.TYPE,
                                key: 'integration_type_display',
                                type: 'string'
                            },
                            {
                                displayName: Strings['en'].analytics.overview.assignment_table.CREATE_DATE,
                                key:'create_date',
                                type: 'date'
                            },
                            {
                                displayName: Strings['en'].analytics.overview.assignment_table.STUDENTS,
                                key: 'student_count',
                                type: 'int'
                            },
                            {
                                displayName: Strings['en'].analytics.overview.assignment_table.SCORING,
                                key: 'score_type_display',
                                type: 'string'
                            },
                            {
                                displayName: Strings['en'].analytics.overview.assignment_table.ATTEMPTS,
                                key: 'attempts_display',
                                type: 'string'
                            },
                            {
                                displayName: Strings['en'].analytics.overview.assignment_table.LAST_ATTEMPT,
                                key: 'last_attempt_date',
                                type: 'date'
                            },
                            {
                                displayName: Strings['en'].analytics.overview.assignment_table.STARTED,
                                key: 'started_attempt_count',
                                type: 'int'
                            },
                            {
                                displayName: Strings['en'].analytics.overview.assignment_table.COMPLETED,
                                key: 'completed_attempt_count',
                                type: 'int'
                            },
                            {
                                displayName: Strings['en'].analytics.overview.assignment_table.TOTAL_TP,
                                key: 'total_time_played',
                                type: 'duration'
                            },
                            {
                                displayName: Strings['en'].analytics.overview.assignment_table.AVG_TP,
                                key: 'avg_time_played',
                                type: 'duration',
                                width: '10%'
                            },
                            {
                                displayName: Strings['en'].analytics.overview.assignment_table.AVG_SCR,
                                key: 'avg_score',
                                type: 'int',
                                width: '10%'
                            }
                        ]}
                />
            </div>
        );
    }
}

ChannelActivityAssignmentsTable.propTypes = propTypes;
ChannelActivityAssignmentsTable.defaultProps = defaultProps;

export default ChannelActivityAssignmentsTable;